import React from "react";
import clsx from "clsx";
import {
  Theme,
  withStyles,
} from "@material-ui/core/styles";
import MuiExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import OffRoadCustomerReqTable from "./OffRoadCustomerReqTable";
import Box from "@material-ui/core/Box";
import {useRequirementPanelStyles} from "../../../../../../common/styles/CustomerRequirementStyles";

const ExpansionPanel = withStyles((theme: Theme) => ({
  root: {
    marginBottom: theme.spacing(2),
    "&.Mui-expanded:last-child": {
      marginBottom: theme.spacing(2),
    },
  },
}))(MuiExpansionPanel);

const useStyles = useRequirementPanelStyles;

interface Props {
  stepData: any;
  data: any;
  available_quantities: any;
  customer: { id: number; index: number };
  allocateUpdateCustomerReq: any;
}

const OffRoadCustomerReqPanel: React.FC<Props> = ({
                                             stepData,
                                             data,
                                             available_quantities,
                                             customer,
                                             allocateUpdateCustomerReq,
                                           }) => {
  const classes = useStyles();

  const getStatus = (cust_id: any): string => {
    let status = "Complete";
    if (data && data.customer_requirements)
      for (var i = 0; i < data.customer_requirements.length; i++) {
        let req = data.customer_requirements[i];
        let sumFame = stepData.sumAllocated[cust_id][req.id]["fame"];
        let sumFameAdvanced = stepData.sumAllocated[cust_id][req.id]["fame_advanced"];
        let sumHvoHro = stepData.sumAllocated[cust_id][req.id]["hvo_hro"];
        let sumHvoHroAdvanced = stepData.sumAllocated[cust_id][req.id]["hvo_hro_advanced"];

        if (
            sumFame < req.required_emission_reduction_fame ||
            sumFameAdvanced < req.required_emission_reduction_fame_advanced ||
            sumHvoHro < req.required_emission_reduction_hvo_hro ||
            sumHvoHroAdvanced < req.required_emission_reduction_hvo_hro_advanced
        )
          return (status = "Not Complete");
        if (
            sumFame > req.required_emission_reduction_fame ||
            sumFameAdvanced > req.required_emission_reduction_fame_advanced ||
            sumHvoHro > req.required_emission_reduction_hvo_hro ||
            sumHvoHroAdvanced > req.required_emission_reduction_hvo_hro_advanced
        )
          status = "Overallocated";
      }
    return status;
  };

  return (
      <div>
        <ExpansionPanel>
          <ExpansionPanelSummary
              expandIcon={<ExpandMoreIcon className={classes.iconExpand} />}
          >
            <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                className={classes.row}
            >
              <Typography
                  className={classes.heading}
                  variant="body1"
                  color="primary"
              >
                {data.name}
              </Typography>
              <Box display="flex" alignItems="center">
                <div
                    className={clsx(classes.circle, {
                      [classes.red]: getStatus(customer.id) === "Not Complete",
                      [classes.yellow]: getStatus(customer.id) === "Overallocated",
                      [classes.green]: getStatus(customer.id) === "Complete",
                    })}
                ></div>
                <Typography variant="body2" color="primary">
                  {data.requirements_count > 1
                      ? data.requirements_count + " requirements"
                      : data.requirements_count + " requirement"}
                </Typography>
              </Box>
            </Box>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <OffRoadCustomerReqTable
                stepData={stepData}
                requirements={data.customer_requirements}
                available_quantities={available_quantities}
                customer={customer}
                allocateUpdateCustomerReq={allocateUpdateCustomerReq}
            />
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </div>
  );
};

export default OffRoadCustomerReqPanel;
